import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.loyaltyApiBaseUrl;

export default {
  async fetchRedeemRewards(query) {
    const queryString = `${query}&join=reward&join=client`;
    const url = `${URL}v1/rewards/redeem${queryString}`;
    return (await httpClient.get(url)).data;
  },
  async redeemReward(payload) {
    const url = `${URL}v1/rewards/redeem`;
    return await httpClient.post(url, payload);
  },
};
